import { getAllQuestionnaireAnswers } from "@medplum/core";
import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { EncounterAnswersLinkIds } from "@/encounters/constants/questionnaire-questions";
import { stripHtmlTags } from "@/utils/regex";

import { AmendmentCardGroup } from "./AmendmentCardGroup";

export const EncounterNoteDifference = ({
  currentVersion,
  previousVersion,
  questionLinkId = EncounterAnswersLinkIds.Note,
}: {
  currentVersion?: QuestionnaireResponse;
  previousVersion?: QuestionnaireResponse;
  questionLinkId?: string;
}) => {
  if (!currentVersion || !previousVersion) return null;

  const currentAnswers = getAllQuestionnaireAnswers(currentVersion);
  const previousAnswers = getAllQuestionnaireAnswers(previousVersion);

  const currentNote = stripHtmlTags(currentAnswers[questionLinkId]?.[0]?.valueString);
  const previousNote = stripHtmlTags(previousAnswers[questionLinkId]?.[0]?.valueString);

  return (
    <AmendmentCardGroup
      title="Encounter Note"
      currentVersion={currentNote}
      previousVersion={previousNote}
    />
  );
};
